<template>
    <div class="loading-small">
        <div class="loading-content">
            <span class="loading-bar"></span>
        </div>
    </div>
</template>


<script>
export default {
    name: 'loadingSpinnerSmall',
    
    data() {
        return {

        }
    }
}
</script>

<style>
    /* Loading screen */

    .loading-bar {
        display: inline-block;
        width: 30px;
        height: 30px;
        border: 4px solid blue;
        border-radius: 50%;
        border-top-color: blue;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
        animation: spinLoader 1s infinite;
        margin-bottom: 10px;
    }

    @keyframes spinLoader {
        0% {transform: rotate(0deg)}
        100% {transform: rotate(359deg)}
    }
</style>



// WEBPACK FOOTER //
// src/components/LoadSpinnerSmall.vue